import {EnumLanguage} from "../EnumLanguage";

export const UXDocuments = {
    documents:{
        instructionForAdmin: {
            [EnumLanguage.ru]: 'Руководство администратора',
            [EnumLanguage.en]: 'Administrator\'s Manual',
            [EnumLanguage.cn]: '管理员说明'
        },
        instructionForUser: {
            [EnumLanguage.ru]: 'Руководство пользователя',
            [EnumLanguage.en]: 'User manual',
            [EnumLanguage.cn]: '用户手册'
        },
        technicalSupport:{
            [EnumLanguage.ru]: "Положение о технической поддержке",
            [EnumLanguage.en]: "Regulations on technical support",
            [EnumLanguage.cn]: "提供技术支持",
        },
        systemDescription:{
            [EnumLanguage.ru]: 'Описание музейной информационной системы',
            [EnumLanguage.en]: 'Description of the museum information system',
            [EnumLanguage.cn]: ''
        },
        certificateOfRegistration:{
            [EnumLanguage.ru]: 'Свидетельство о государственной регистрации программы для ЭВМ',
            [EnumLanguage.en]: 'Certificate of state registration of the computer program',
            [EnumLanguage.cn]: ''
        }
    }
}